/**
 * QRCode — TOTP provisioning-URI rendering (HoD §4.1).
 *
 * Wraps ``qrcode.react``'s SVG renderer with the HoD-spec'd white
 * backplate so the QR stays scanner-friendly in dark mode. **Never
 * theme-switch the QR fg/bg colors** — TOTP scanners require a light
 * background and inverted (white-on-black) codes fail in many camera
 * apps. The white tile is a deliberate stylistic island in the dark
 * card — Stripe's pattern.
 */
import { QRCodeSVG } from "qrcode.react";
import { QR_COLOR_BG, QR_COLOR_FG } from "@/lib/tokens";

interface QRCodeProps {
  /** ``otpauth://...`` URI from the backend. */
  value: string;
  size?: number;
  /** Override for screen-reader alt text. */
  ariaLabel?: string;
}

export function QRCode({
  value,
  size = 192,
  ariaLabel = "QR code containing your authenticator setup secret",
}: QRCodeProps): JSX.Element {
  return (
    <div
      className="rounded-lg bg-white p-3 shadow-sm"
      aria-label={ariaLabel}
      role="img"
    >
      <QRCodeSVG
        value={value}
        size={size}
        level="M"
        bgColor={QR_COLOR_BG}
        fgColor={QR_COLOR_FG}
        marginSize={0}
      />
    </div>
  );
}
